import styled, { keyframes } from 'styled-components';

export const patientsModalWidth = 364;

const translateInAnimation = keyframes`
 0% { transform: translateX(-${patientsModalWidth}px); }
 100% { transform: translateX(0px); }
`;

const translateOutAnimation = keyframes`
 0% { transform: translateX(0px); }
 100% { transform: translateX(-${patientsModalWidth}px) }
`;

export const Container = styled.div`
  height: 100%;
  animation-duration: 0.5s;
  box-shadow: ${({ theme }) => theme.yoga.elevations.small};
  background-color: ${({ theme }) => theme.yoga.colors.white};

  & .open {
    animation-name: ${translateInAnimation};
  }

  & .close {
    animation-name: ${translateOutAnimation};
  }
`;
